import assignIn from "lodash/assignIn";

// @ts-expect-error legacy
import Formatter from "@/legacy/Formatter.js";
import {SingleMetric} from "@/pages/pagespeed/report/body/performance/SingleMetric.tsx";
import {LHRAudit} from "@/pages/pagespeed/types.ts";

interface InformativeMetricsProps {
  audits: Record<string, LHRAudit>;
}

export const InformativeMetrics = ({audits}: InformativeMetricsProps) => {
  if (audits.metrics === undefined || audits.metrics.details === undefined) {
    return null;
  }
  // @ts-expect-error legacy
  const items = audits.metrics.details.items || [];
  // @ts-expect-error: combine all objects in items in one object
  const data = items.reduce((result, item) => assignIn(result, item), {});

  const showMetrics: LHRAudit[] = [
    {
      id: "observedLoad",
      title: "Observed Load",
      description: "The time it took to load the page and all of its resources, as observed by the browser.",
      displayValue: Formatter.ms(data.observedLoad),
    },
    {
      id: "observedDomContentLoaded",
      title: "Observed DOM Content Loaded",
      description: "The time it took to load the html page, as observed by the browser.",
      displayValue: Formatter.ms(data.observedDomContentLoaded),
    },
    {
      id: "observedFirstVisualChange",
      title: "Observed First Visual Change",
      description: "The time it took to load the first visual change, as observed by the browser.",
      displayValue: data.observedFirstVisualChange + " ms",
    },
  ];
  return (
    <div className="mt-2">
      <h5>Informative Metrics</h5>
      <div className="d-flex audit-metrics-container">
        {showMetrics.map((m) => (
          <SingleMetric key={m.id} audit={m} />
        ))}
      </div>
    </div>
  );
};
